import { render, staticRenderFns } from "./MaintenanceRecords.vue?vue&type=template&id=ef52e05e&scoped=true"
import script from "./MaintenanceRecords.vue?vue&type=script&lang=js"
export * from "./MaintenanceRecords.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceRecords.vue?vue&type=style&index=0&id=ef52e05e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef52e05e",
  null
  
)

export default component.exports